import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Freight.css";
import config from "../../config";
import { useAuth } from "../../Auth/AuthContext";

const getFreightDataUrl = `${config.BASE_URL}/list-freight`;
const insertFreightDataUrl = `${config.BASE_URL}/add-freight`;
const updateFreightDataUrl = `${config.BASE_URL}/update-freight`;
const deleteFreightDataUrl = `${config.BASE_URL}/delete-freight`;
const Freight = () => {
    const [result, setResult] = useState([]);
    const [error, setError] = useState(false);
    const [formData, setFormData] = useState({
        from_destination: "",
        to_destination: "",
        rate: "",
    });
    const [submitMessage, setSubmitMessage] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [editingData, setEditingData] = useState({});
    const editRef = useRef(null); // Ref for the edit area (row)
    const [deleteModal, setDeleteModal] = useState({
        isOpen: false,
        recordId: null,
    });



    const { userProfile, setActiveModule } = useAuth();

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        sessionStorage.setItem('actMod', 'freight');
        setActiveModule(sessionStorage.getItem('actMod'));

    }, []);

    const fetchData = async () => {
        try {
            setError(false);
            const response = await axios.get(getFreightDataUrl,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );

            if (response?.data && Array.isArray(response.data)) {
                console.log('Result Data:', response.data);
                setResult(response.data);
            } else {
                setResult([]);
            }
        } catch (error) {
            setError(true);
            console.error("Error while fetching data:", error);
        }
    };

    const capitalizeWords = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const capitalize = capitalizeWords(value);
        setFormData({ ...formData, [name]: capitalize });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(insertFreightDataUrl, formData,
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );
            const newEntry = {
                id: result.length + 1,
                from: formData.from_destination,
                to: formData.to_destination,
                rate: Math.round(formData.rate),
            };

            setResult((prev) => [...prev, newEntry]);

            setFormData({
                from_destination: "",
                to_destination: "",
                rate: ""
            });

            setSubmitMessage("Data submitted successfully!");
            fetchData(); // Refresh the data
            setTimeout(() => {
                setSubmitMessage("");
            }, 3000);
        } catch (error) {
            console.error("Error while submitting data:", error);
            if (error.response && error.response.status === 409) {
                setSubmitMessage("Duplicate entry detected. Please check the data.");
            } else {
                setSubmitMessage("Failed to submit data. Please try again.");
            }
        }
    };

    const handleEdit = (id) => {
        const shipment = result.find((item) => item.id === id);
        setEditingId(id);
        // setEditingData({ ...shipment });
        setEditingData({
            from_destination: shipment.from, // Initialize with previous "from" value
            to_destination: shipment.to,   // Initialize with previous "to" value
            rate: Math.round(shipment.rate),           // Initialize with previous "rate" value
        });
    };

    const handleEditingChange = (e) => {
        const { name, value } = e.target;
        const capitalize = capitalizeWords(value);
        setEditingData({ ...editingData, [name]: capitalize });
    };

    const handleSave = async (_id) => {
        try {
            const payload = {
                old: result.find((item) => item._id === _id),
                new: editingData,
            };

            const response = await axios.post(updateFreightDataUrl, payload, {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.status === 200) {
                setResult((prev) =>
                    prev.map((item) =>
                        item._id === _id
                            ? {
                                ...item,
                                from: editingData.from_destination,
                                to: editingData.to_destination,
                                rate: editingData.rate,
                            }
                            : item
                    )
                );
                setEditingId(null);
                setEditingData({});
                alert("Freight updated successfully!");
                fetchData();
            } else {
                alert("Failed to update row.");
            }
        } catch (error) {
            console.error("Error updating row:", error);
            setResult((prev) => [...prev]);
            setEditingId(null);
            setEditingData({});
            if (error.response) {
                if (error.response.status === 409) {
                    alert("Conflict: Freight already exists.");
                } else if (error.response.status === 404) {
                    alert("Freight entry not found.");
                } else {
                    alert(`Error: ${error.response.data || "Failed to update row."}`);
                }
            } else {
                alert("Network error or server is down.");
            }
        }
    };

    const handleDelete = async (id) => {
        const shipmentToDelete = result.find(shipment => shipment._id === id);

        if (shipmentToDelete) {
            setDeleteModal({
                isOpen: true,
                recordId: id,
                from: shipmentToDelete.from,
                to: shipmentToDelete.to,
                rate: shipmentToDelete.rate
            });
        }
    }

    const confirmDelete = async () => {
        try {
            const response = await axios.delete(`${deleteFreightDataUrl}/${deleteModal.recordId}`, {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                }
            });
            // setResult((prev) => prev.filter((item) => item._id !== deleteModal.recordId));
            if (response.status === 200) {
                console.log("Freight deleted successfully:", deleteModal.recordId);
                alert("Freight deleted successfully!");
                fetchData(); // Refresh the data
            } else {
                alert("Failed to delete Freight.");
            }
            setDeleteModal({ isOpen: false, recordId: null });
            // Show success notification (you could add a toast notification system here)
        } catch (error) {
            console.error('Error deleting Freight:', error);

            let errorMessage = 'Error deleting Freight';
            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }

            alert(errorMessage);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check if the click is outside the current edit row
            if (editRef.current && !editRef.current.contains(event.target)) {
                console.log("Clicked outside, resetting edit mode.");
                setEditingId(null);
                setEditingData({});
            }
        };

        // Attach the event listener
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup the event listener
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div id="freight">
            <div className="container-freight">
                <div className="form-wrapper">
                    <form id="shipmentForm" autoComplete="off">
                        <div className="filter-item">
                            <label htmlFor="from_destination">From Destination:</label>
                            <input
                                type="text"
                                id="from_destination"
                                name="from_destination"
                                value={formData.from_destination}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="filter-item">
                            <label htmlFor="to_destination">To Destination:</label>
                            <input
                                type="text"
                                id="to_destination"
                                name="to_destination"
                                value={formData.to_destination}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="filter-item">
                            <label htmlFor="rate">Rate:</label>
                            <input
                                type="number"
                                id="rate"
                                name="rate"
                                value={formData.rate}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </form>
                    <button className="submit-button" type="submit" onClick={handleFormSubmit}>Submit</button>
                    <p>{submitMessage}</p>
                </div>

                <div className="table-wrapper" id="results">
                    {/* <h2>Current Rates</h2> */}
                    <div className="scrollable-table">
                        <table id="resultsTable">
                            <thead>
                                <tr>
                                    <th>Index</th>
                                    <th>From Destination</th>
                                    <th>To Destination</th>
                                    <th>Rate</th>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {error ? (
                                    <tr>
                                        <td colSpan="5">Error fetching data. Please try again later.</td>
                                    </tr>
                                ) : result.length === 0 ? (
                                    <tr>
                                        <td colSpan="5" className="empty-row">
                                            No freight data available.
                                        </td>
                                    </tr>
                                ) : (
                                    result.map((shipment) => (
                                        <tr
                                            key={shipment.id}
                                            ref={editingId === shipment.id ? editRef : null} // Attach ref to the row
                                            className={editingId === shipment.id ? "editing" : ""}
                                        >
                                            <td>{shipment.id}</td>
                                            <td>
                                                {editingId === shipment.id ? (
                                                    <input
                                                        className="editInput"
                                                        type="text"
                                                        name="from_destination"
                                                        value={editingData.from_destination || ""}
                                                        onChange={handleEditingChange}
                                                    />
                                                ) : (
                                                    shipment.from
                                                )}
                                            </td>
                                            <td>
                                                {editingId === shipment.id ? (
                                                    <input
                                                        className="editInput"
                                                        type="text"
                                                        name="to_destination"
                                                        value={editingData.to_destination || ""}
                                                        onChange={handleEditingChange}
                                                    />
                                                ) : (
                                                    shipment.to
                                                )}
                                            </td>
                                            <td>
                                                {editingId === shipment.id ? (
                                                    <input
                                                        className="editInput"
                                                        type="number"
                                                        name="rate"
                                                        value={editingData.rate || ""}
                                                        onChange={handleEditingChange}
                                                    />
                                                ) : (
                                                    shipment.rate
                                                )}
                                            </td>
                                            <td>
                                                {editingId === shipment.id ? (
                                                    <button
                                                        className="save-btn"
                                                        onClick={() => handleSave(shipment._id)}
                                                    >
                                                        Save
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="edit-btn"
                                                        onClick={() => handleEdit(shipment.id)}
                                                    >
                                                        Edit
                                                    </button>
                                                )}
                                            </td>
                                            {/* {
                                            (userProfile !== 'loadingManager' && userProfile !== 'unloadingManager')
                                            && */}
                                            <td>
                                                <button
                                                    className="delete-btn"
                                                    onClick={() => handleDelete(shipment._id)} // Open the modal with the ID
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                            {/* } */}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    {deleteModal.isOpen && (
                        <div className="delete-modal-overlay">
                            <div className="delete-modal">
                                <div className="delete-modal-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="54" height="54">
                                        <path fill="none" d="M0 0h24v24H0z" />
                                        <path fill="#ff4757" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-11.414L9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586z" />
                                    </svg>
                                </div>
                                <h3>Confirm Delete</h3>
                                <p>
                                    Are you sure you want to delete this freight?
                                    <span className="trip-id-highlight"></span><br></br>
                                    <b>From</b>: {deleteModal.from}, <b>To</b>: {deleteModal.to}, <b>Rate</b>: {deleteModal.rate}
                                </p>
                                <p className="warning-text">This action cannot be undone.</p>
                                <div className="delete-modal-buttons">
                                    <button className="cancel-btn" onClick={() => setDeleteModal({ isOpen: false, recordId: null })}>
                                        Cancel
                                    </button>
                                    <button className="confirm-delete-btn" onClick={confirmDelete}>
                                        Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Freight;